import {ref, Ref} from "vue"
import { BookingFunnelConfigurationDTO } from "../../../requests-module/src"

const bookigFunnelSingleCompanyConfig: Ref<BookingFunnelConfigurationDTO | null> = ref(null)

export default bookigFunnelSingleCompanyConfig